import { RGBAColor } from "core/math";
import { IsIOSMTags } from "./osm.interfaces";
import { OSMTagSet } from "./osm.tagset";
export var RoofShape;
(function (RoofShape) {
    RoofShape[RoofShape["flat"] = 0] = "flat";
    RoofShape[RoofShape["skillion"] = 1] = "skillion";
    RoofShape[RoofShape["gabled"] = 2] = "gabled";
    RoofShape[RoofShape["halfHipped"] = 3] = "halfHipped";
    RoofShape[RoofShape["hipped"] = 4] = "hipped";
    RoofShape[RoofShape["pyramidal"] = 5] = "pyramidal";
    RoofShape[RoofShape["gambrel"] = 6] = "gambrel";
    RoofShape[RoofShape["mansard"] = 7] = "mansard";
    RoofShape[RoofShape["dome"] = 8] = "dome";
    RoofShape[RoofShape["onion"] = 9] = "onion";
    RoofShape[RoofShape["round"] = 10] = "round";
    RoofShape[RoofShape["saltbox"] = 11] = "saltbox";
})(RoofShape || (RoofShape = {}));
export var RoofOrientation;
(function (RoofOrientation) {
    RoofOrientation[RoofOrientation["along"] = 0] = "along";
    RoofOrientation[RoofOrientation["across"] = 1] = "across";
})(RoofOrientation || (RoofOrientation = {}));
export class BuildingMaterialOptions {
    constructor() {
        this.color = null;
        this.material = null;
    }
}
export class RoofOptions {
    constructor() {
        this.shape = RoofShape.flat;
        this.orientation = 0;
        this.height = 0;
        this.angle = 0;
        this.levels = 0;
        this.direction = 0;
        this.material = null;
    }
    static IsRoof(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        return tags.readValue("roof:shape") !== undefined;
    }
    static FromTags(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        if (!this.IsRoof(tags)) {
            return undefined;
        }
        const o = new RoofOptions();
        const shapeVal = tags.readValue("roof:shape");
        if (shapeVal && RoofShape.hasOwnProperty(shapeVal)) {
            o.shape = RoofShape[shapeVal];
        }
        const orientation = tags.readValue("roof:orientation");
        if (orientation === "across") {
            o.orientation = RoofOrientation.across;
        }
        o.height = tags.readFloat("roof:height", 0);
        o.angle = tags.readFloat("roof:angle", 0);
        o.levels = tags.readInt("roof:levels", 0);
        const dir = tags.readValue("roof:direction");
        if (dir) {
            o.direction = this.CardinalDirections.get(dir) ?? parseFloat(dir);
        }
        const color = tags.readValue("roof:colour");
        const mat = tags.readValue("roof:material");
        if (color || mat) {
            o.material = {
                color: color ? RGBAColor.Parse(color) : null,
                material: mat ?? null,
            };
        }
        return o;
    }
}
RoofOptions.CardinalDirections = new Map([
    ["N", 0],
    ["NNE", 22],
    ["NE", 45],
    ["ENE", 67],
    ["E", 90],
    ["ESE", 112],
    ["SE", 135],
    ["SSE", 157],
    ["S", 180],
    ["SSW", 202],
    ["SW", 225],
    ["WSW", 247],
    ["W", 270],
    ["WNW", 292],
    ["NW", 315],
    ["NNW", 337],
]);
RoofOptions.Shapes = new Map([
    ["flat", RoofShape.flat],
    ["skillion", RoofShape.skillion],
    ["gabled", RoofShape.gabled],
    ["halfHipped", RoofShape.halfHipped],
    ["hipped", RoofShape.hipped],
    ["pyramidal", RoofShape.pyramidal],
    ["gambrel", RoofShape.gambrel],
    ["mansard", RoofShape.mansard],
    ["dome", RoofShape.dome],
    ["onion", RoofShape.onion],
    ["round", RoofShape.round],
    ["saltbox", RoofShape.saltbox],
]);
export class BuildingOptions {
    constructor() {
        this.height = 0;
        this.min_height = 0;
        this.levels = 0;
        this.min_levels = 0;
        this.material = null;
        this.roof = null;
    }
    static IsBuilding(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        return tags.readValue("building") !== undefined || tags.readValue("building:part") !== undefined;
    }
    static FromTags(record) {
        var tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        if (!this.IsBuilding(tags)) {
            return undefined;
        }
        var o = new BuildingOptions();
        let str;
        o.height = tags.readInt("height", 0);
        o.min_height = tags.readInt("min_height", 0);
        o.levels = tags.readInt("building:levels", 0);
        o.min_levels = tags.readInt("building:min_level", 0);
        o.roof = RoofOptions.FromTags(tags) ?? null;
        var om = new BuildingMaterialOptions();
        str = tags.readValue("building:colour");
        if (str) {
            om.color = RGBAColor.Parse(str);
        }
        om.material = tags.readValue("building:material") ?? null;
        o.material = om.color || om.material ? om : null;
        return o;
    }
}
//# sourceMappingURL=osm.interfaces.building.js.map